export default __webpack_public_path__ + "static/media/our-services-home-care-live-in-care-01.7e9040be.jpg";